/**
 * @ngdoc directive
 * @name formcheckpassword
 *
 * @description
 * Page footer
 */
module.directive('formConfirm', function () {
    'use strict';
    return {
        restrict: 'EA',
        require: "ngModel",
        scope: {
            reference: "=formConfirm"
        },
        link: function ($scope, element, attr, model) {
            model.$validators.confirmation = function (value) {
                return value === $scope.reference;
            };

            $scope.$watch("reference", function () {
                model.$validate();
            });
        }
    };
});